import React from 'react';
import styled from 'styled-components';

import Hero from '../components/home/Hero';
import QuoteHero from '../components/home/QuoteHero';
import Service from '../components/home/Service';
import WhyChooseUs from '../components/whyChooseUs';
import HowWeHelp from '../components/howWeHelp';
import Testimonial from '../components/testimonials';
import Team from '../components/team';
import HowWeWork from '../components/work/HowWeWork';
import AllNewsSection from '../components/news/AllNewsSection';
import LatestNews from '../components/news/LatestNews';
import ContactFormBlock from '../components/contact/ContactFormBlock';
import ContactInfo from '../components/contact/ContactInfo';
import TextBlock from '../components/global/TextBlock';
import Faq from '../components/faq/Faq';
import Calculator from '../components/global/Calculator';
import AllServices from '../components/services/AllServices';
import InfoBlock from '../components/services/InfoBlock';
import AllCaseStudy from '../components/caseStudy/AllCaseStudy';

// sanity blocks
const Blocks = {
  hero: Hero,
  quoteHero: QuoteHero,
  whyChooseUs: WhyChooseUs,
  howWeHelp: HowWeHelp,
  testimonialSection: Testimonial,
  ourTeamSection: Team,
  homeServices: Service,
  howWeWork: HowWeWork,
  allNewsSection: AllNewsSection,
  latestNewsSection: LatestNews,
  contactFormSection: ContactFormBlock,
  contact: ContactInfo,
  textBlock: TextBlock,
  faq: Faq,
  calculator: Calculator,
  allServices: AllServices,
  infoBlock: InfoBlock,
  allCaseStudy: AllCaseStudy,
};

const ContentBlocks = (type) => {
  const BlockNotFound = () => (
    <div className="section">
      <div className="container">
        <PreWrapper>
          Error: The requested component
          <em className="has-text-black">{type}</em> could not be found.
        </PreWrapper>
      </div>
    </div>
  );

  if (typeof Blocks[type] === 'undefined') {
    return BlockNotFound;
  }
  return Blocks[type];
};

export default ContentBlocks;

const PreWrapper = styled.pre`
  padding: 5.6rem 0;
  text-align: center;
  border: 1px solid var(--coral);
  color: var(--black);
  white-space: normal;
  line-height: 1.4;
`;
